import React from "react";
import { FaPlane, FaWhatsapp } from "react-icons/fa";

const SellBanner = () => {
  const whatsappNumber = "27621035788";

  const message =
    "Hi! To get your products listed on SwellenShop, please send the following for each product:\n\n" +
    "• Product name\n" +
    "• Price\n" +
    "• Description (please provide a clear and detailed description)\n" +
    "• Town where the product is located (e.g. Swellendam)\n" +
    "• At least 1 clear, good-quality picture (up to 4 pictures per product)\n\n" +
    "You can send the details and pictures directly here on WhatsApp.";

  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <div className="relative h-16 overflow-hidden bg-green-900">

      {/* Entire moving unit */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="absolute left-0 top-1/2 block -translate-y-1/2 animate-fly cursor-pointer"
      >
        <div className="flex items-center">

          {/* Banner */}
          <div className="relative flex items-center justify-center bg-green-800 border border-white/30 px-6 py-2.5 text-white shadow-md">
            <div className="flex items-center justify-center gap-2.5 text-base sm:text-lg whitespace-nowrap">

              <span className="font-semibold">
                Want to sell something?
              </span>

              <span className="text-white/40">
                •
              </span>

              <span className="flex items-center gap-2 font-semibold">
                <FaWhatsapp className="text-lg sm:text-xl" />
                Click here to get your products on SwellenShop!
              </span>

            </div>
          </div>

          {/* Rope */}
          <div className="w-10 sm:w-14 h-px bg-white/60" />

          {/* Plane */}
          <FaPlane className="shrink-0 text-white text-xl sm:text-2xl rotate-12" />

        </div>
      </a>

      <style>
        {`
          @keyframes fly {
            0% {
              transform: translateX(calc(-100% - 40px)) translateY(-50%);
            }

            100% {
              transform: translateX(100vw) translateY(-50%);
            }
          }

          .animate-fly {
            animation: fly 20s linear infinite;
            will-change: transform;
          }
        `}
      </style>

    </div>
  );
};

export default SellBanner;
